var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPin = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.463 12.668a.751.751 0 0 1-.07.08l-5.08 5.081a.75.75 0 1 1-1.061-1.06l5.08-5.081a.758.758 0 0 1 .081-.07l-.386-.386-2.536-2.537a1.12 1.12 0 0 1-.331-.8c0-.266.092-.542.285-.753a4.598 4.598 0 0 1 3.593-1.516h.193a2.74 2.74 0 0 0 2.739-2.739v-.67c0-.304.119-.589.33-.8a1.143 1.143 0 0 1 1.608 0l5.68 5.68c.211.21.33.495.33.799 0 .625-.514 1.14-1.13 1.14h-.67a2.74 2.74 0 0 0-2.74 2.738V11.986a4.995 4.995 0 0 1-1.47 3.528 1.143 1.143 0 0 1-1.608 0l-2.536-2.546-.3-.3Zm-.486-5.544.03.002h.224a4.24 4.24 0 0 0 4.233-4.032L18.91 7.54a4.24 4.24 0 0 0-4.031 4.234V11.986c0 .798-.28 1.574-.787 2.197l-2.266-2.273-.001-.002-1.737-1.737-2.276-2.275a3.098 3.098 0 0 1 2.165-.772Z",
  fill: "currentColor"
})));
export { SvgPin as ReactComponent };